import { render, staticRenderFns } from "./IframeFReportView.vue?vue&type=template&id=252e3ced"
import script from "./IframeFReportView.vue?vue&type=script&lang=js"
export * from "./IframeFReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports